function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("circle", {
  cx: 40.75,
  cy: 40,
  r: 40,
  fill: "#C4C4C4"
});

var _ref3 = /*#__PURE__*/React.createElement("circle", {
  cx: 40.75,
  cy: 40,
  r: 40,
  fill: "white"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M0.75 -14.9768L80.75 -15L80.7442 11.6929C78.3171 14.9945 74.2472 16.3875 68.5343 15.8719C59.9649 15.0988 44.9198 8.13749 27.9438 8.13749C16.6264 8.13749 7.56184 11.8028 0.75 19.1333V-14.9768Z",
  fill: "white"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M35.7073 50.8685C36.0929 50.7679 36.4828 50.6445 36.8993 50.4913C36.9168 50.4849 36.9334 50.4729 36.9507 50.4651C37.3601 50.7802 37.6915 51.1854 37.919 51.6493C38.1466 52.1132 38.2642 52.6232 38.2628 53.1399C38.264 53.3054 38.3308 53.4636 38.4485 53.5799C38.5662 53.6962 38.7253 53.7611 38.8908 53.7603C39.0563 53.7594 39.2147 53.693 39.3313 53.5756C39.4478 53.4582 39.5131 53.2993 39.5127 53.1338C39.5169 52.441 39.3631 51.7565 39.0629 51.1321C38.7626 50.5078 38.324 49.9602 37.7803 49.5309C38.0953 48.9086 38.3415 48.2538 38.5144 47.578C39.7631 42.2947 37.8303 38.5132 32.7697 36.3386C30.2286 35.2467 25.8808 33.7473 26.6564 30.1628C26.6839 30.0353 26.6708 29.9024 26.619 29.7828C26.5671 29.6631 26.4792 29.5627 26.3674 29.4955C26.2556 29.4283 26.1256 29.3978 25.9956 29.4082C25.8656 29.4187 25.7422 29.4695 25.6425 29.5536C23.2919 31.5367 21.7099 33.3407 21.0871 36.2037C20.6587 38.0429 20.6384 39.9536 21.0275 41.8016C21.4166 43.6495 22.2058 45.3898 23.3395 46.9001C25.3764 49.6666 28.9088 51.2686 32.5742 51.2686C33.6314 51.2692 34.6843 51.1348 35.7073 50.8685ZM24.3462 46.16C23.3196 44.7914 22.6051 43.2146 22.2531 41.5404C21.9011 39.8661 21.9201 38.1351 22.3086 36.469C22.7545 34.419 23.7942 32.9573 25.3261 31.5058C25.6585 34.947 29.5669 36.322 32.276 37.4861C36.8215 39.4393 38.4173 42.5548 37.298 47.291C37.1564 47.8237 36.9664 48.3423 36.7305 48.8405C35.5697 48.1867 32.875 46.521 31.2665 44.3362C31.2179 44.2701 31.1567 44.2142 31.0866 44.1718C31.0164 44.1293 30.9385 44.101 30.8574 44.0887C30.7763 44.0763 30.6935 44.08 30.6139 44.0996C30.5342 44.1192 30.4592 44.1543 30.3931 44.2029C30.327 44.2515 30.2711 44.3126 30.2286 44.3828C30.1861 44.453 30.1579 44.5309 30.1455 44.612C30.1331 44.6931 30.1369 44.7758 30.1565 44.8555C30.176 44.9352 30.2111 45.0102 30.2597 45.0763C31.7956 47.1627 34.1558 48.7687 35.564 49.6103C35.5068 49.6263 35.4482 49.6453 35.3913 49.6601C31.9708 50.5534 27.0551 49.8389 24.3462 46.16Z",
  fill: "black"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  d: "M57.536 30.9531C55.3928 28.6895 52.4535 27.3477 49.3393 27.2112C46.225 27.0748 43.1796 28.1544 40.8466 30.2219C40.8233 30.2421 40.7934 30.2532 40.7626 30.2532C40.7317 30.2532 40.7018 30.2421 40.6785 30.2219C38.8623 28.6118 36.6007 27.5901 34.192 27.2916C31.7834 26.9931 29.3408 27.4318 27.1865 28.5498C27.4678 28.7652 27.6821 29.0561 27.8044 29.3886C27.9267 29.7211 27.9519 30.0816 27.8772 30.4279C27.4181 32.5501 29.7635 33.7216 32.6419 34.9283C32.8576 35.0187 33.0656 35.1059 33.2628 35.1906C36.7639 36.6951 38.9512 38.9636 39.7676 41.8809H44.1561C44.2454 41.8408 44.3239 41.78 44.3852 41.7037L45.5233 36.9856C45.5726 36.7782 45.6906 36.5934 45.8581 36.4615C46.0256 36.3295 46.2328 36.258 46.4461 36.2586C46.6578 36.2664 46.8606 36.3459 47.0211 36.4842C47.1816 36.6225 47.2904 36.8112 47.3295 37.0195L48.6494 44.0864L50.4324 39.2254C50.4385 39.2096 50.4449 39.1937 50.4519 39.1783C50.5234 39.0157 50.6403 38.8771 50.7887 38.7794C50.937 38.6817 51.1104 38.629 51.2881 38.6276H51.2884C51.466 38.6289 51.6394 38.6816 51.7878 38.7792C51.9362 38.8768 52.0532 39.0152 52.1248 39.1777L53.1937 41.6314C53.2408 41.7222 53.3001 41.8061 53.37 41.8809H60.4125C60.8797 39.9639 60.8614 37.9606 60.3591 36.0524C59.8569 34.1443 58.8865 32.3916 57.536 30.9531Z",
  fill: "black"
});

var _ref7 = /*#__PURE__*/React.createElement("path", {
  d: "M52.0541 42.1439L51.3153 40.4476L49.4045 45.6562C49.3984 45.6724 49.392 45.6883 49.3847 45.7038C49.3138 45.8661 49.1974 46.0045 49.0496 46.1022C48.9019 46.1998 48.729 46.2527 48.5519 46.2543C48.5188 46.2543 48.4857 46.2524 48.4528 46.2488C48.2548 46.2253 48.0694 46.1394 47.9235 46.0035C47.7776 45.8677 47.6788 45.6889 47.6413 45.493L46.3824 38.752L45.5914 42.0321C45.4883 42.3312 45.3008 42.5941 45.0516 42.789C44.8024 42.9839 44.5021 43.1025 44.187 43.1305H40.0261C40.2232 44.7135 40.1228 46.3194 39.7302 47.8656C39.6108 48.3339 39.462 48.7943 39.2848 49.2441C40.2478 50.3071 40.7752 51.6937 40.7622 53.1279C40.7634 53.3741 40.716 53.618 40.6229 53.8458C40.5298 54.0737 40.3927 54.2809 40.2195 54.4558C40.0463 54.6306 39.8403 54.7697 39.6134 54.8649C39.3864 54.9602 39.143 55.0098 38.8968 55.011H38.8907C38.3952 55.0104 37.9199 54.8141 37.5683 54.4648C37.2167 54.1156 37.0172 53.6416 37.0133 53.1461C37.0179 52.7014 36.8797 52.267 36.619 51.9067C36.4183 51.9694 36.22 52.0262 36.0225 52.0776C34.8966 52.3708 33.7378 52.5189 32.5743 52.5181C31.2318 52.5189 29.8963 52.3243 28.6099 51.9406L39.7854 63.0387C40.0474 63.2925 40.3978 63.4344 40.7626 63.4344C41.1273 63.4344 41.4778 63.2925 41.7398 63.0387L57.1336 47.7515C58.4427 46.4519 59.4393 44.8717 60.0482 43.1305H53.2457C52.5202 43.1305 52.0727 42.1842 52.0541 42.1439Z",
  fill: "black"
});

var SvgCheckIn = function SvgCheckIn(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 81,
    height: 80,
    viewBox: "0 0 81 80",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 81,
    height: 80
  }, _ref2), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0)"
  }, _ref3, /*#__PURE__*/React.createElement("mask", {
    id: "mask1",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: -15,
    width: 81,
    height: 35
  }, _ref4), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.75 13.4673V18.4614L40.75 15.9644L0.75 13.4673Z",
    style: {
      fill: "var(--color-primary)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.8058 15.9271L40.8156 15.9192L40.7979 15.9209L40.7917 15.9254L40.8058 15.9271Z",
    style: {
      fill: "var(--color-primary)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.9001 15.9324L80.75 18.4197V13.4275L41.0245 15.9058L40.9001 15.9324Z",
    style: {
      fill: "var(--color-primary)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.7836 15.9254L40.7873 15.9209L40.7766 15.9218L40.7749 15.9245L40.7836 15.9254Z",
    style: {
      fill: "var(--color-primary)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.758 15.9226H40.7527V15.9245H40.758V15.9226Z",
    style: {
      fill: "var(--color-primary)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.8506 15.9298L40.8958 15.9138L40.8408 15.9172L40.8203 15.9279L40.8506 15.9298Z",
    style: {
      fill: "var(--color-primary)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.7677 15.9199H40.7651V15.927H40.7677V15.9199Z",
    style: {
      fill: "var(--color-primary)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.75 24.4789V29.831L40.75 15.9644L0.75 24.4789Z",
    style: {
      fill: "var(--color-primary)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.75 15.9645L40.9002 15.9325L40.8505 15.9299L40.75 15.9645Z",
    style: {
      fill: "var(--color-primary)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.0244 15.9058L80.75 7.4499V2.09875L40.8958 15.9139L41.0244 15.9058Z",
    style: {
      fill: "var(--color-primary)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.8958 15.9139L40.8503 15.9299L40.9 15.9324L41.0244 15.9058L40.8958 15.9139Z",
    style: {
      fill: "var(--color-primary)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.8946 31.6591L40.75 15.9644L10.5713 31.6591H17.8946Z",
    style: {
      fill: "var(--color-primary)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.8406 15.9173L80.75 -4.83813V-11.5032L40.8157 15.9192L40.8406 15.9173Z",
    style: {
      fill: "var(--color-primary)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.8059 15.927L40.75 15.9643L40.8202 15.9279L40.8059 15.927Z",
    style: {
      fill: "var(--color-primary)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.8202 15.9279L40.8407 15.9172L40.816 15.9192L40.8062 15.9271L40.8202 15.9279Z",
    style: {
      fill: "var(--color-primary)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.3685 31.6591L40.7501 15.9644L23.7344 31.6591H27.3685Z",
    style: {
      fill: "var(--color-primary)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.798 15.9209L80.75 -20.9291V-25.6389H76.2224L40.7874 15.9209H40.798Z",
    style: {
      fill: "var(--color-primary)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.7837 15.9253L40.75 15.9643L40.7918 15.9253H40.7837Z",
    style: {
      fill: "var(--color-primary)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.7918 15.9254L40.798 15.9209H40.7873L40.7837 15.9254H40.7918Z",
    style: {
      fill: "var(--color-primary)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.2054 31.6591L40.7499 15.9644L30.7866 31.6591H33.2054Z",
    style: {
      fill: "var(--color-primary)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.7766 15.9218L67.1586 -25.6389H60.7523L40.7695 15.9218H40.7766Z",
    style: {
      fill: "var(--color-primary)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.7686 15.9246L40.75 15.9645L40.775 15.9246H40.7686Z",
    style: {
      fill: "var(--color-primary)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.7747 15.9199H40.7712V15.927H40.7747V15.9199Z",
    style: {
      fill: "var(--color-primary)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.6613 31.6591L40.75 15.9644L35.7202 31.6591H37.6613Z",
    style: {
      fill: "var(--color-primary)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.7631 15.9226L54.0835 -25.6389H48.9366L40.7578 15.9226H40.7631Z",
    style: {
      fill: "var(--color-primary)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.7579 15.9246L40.75 15.9645L40.7632 15.9246H40.7579Z",
    style: {
      fill: "var(--color-primary)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.7615 15.9209H40.7598V15.9262H40.7615V15.9209Z",
    style: {
      fill: "var(--color-primary)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.6571 31.6591L40.75 15.9644L39.844 31.6591H41.6571Z",
    style: {
      fill: "var(--color-primary)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.7525 15.9246L40.7499 15.9237L40.7525 15.9226L43.1502 -25.6389H38.3506L40.7499 15.9645L40.7525 15.9246Z",
    style: {
      fill: "var(--color-primary)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.75 15.9236L40.7524 15.9244V15.9226L40.75 15.9236Z",
    style: {
      fill: "var(--color-primary)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.7806 31.6591L40.75 15.9644L43.8386 31.6591H45.7806Z",
    style: {
      fill: "var(--color-primary)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.5641 -25.6389H27.4172L40.7499 15.9645L32.5641 -25.6389Z",
    style: {
      fill: "var(--color-primary)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.7125 31.6591L40.75 15.9644L48.2954 31.6591H50.7125Z",
    style: {
      fill: "var(--color-primary)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.7496 -25.6389H14.3413L40.7501 15.9645L20.7496 -25.6389Z",
    style: {
      fill: "var(--color-primary)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.7665 31.6591L40.75 15.9644L54.1307 31.6591H57.7665Z",
    style: {
      fill: "var(--color-primary)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.27774 -25.639H0.75V-20.9301L40.75 15.9643L5.27774 -25.639Z",
    style: {
      fill: "var(--color-primary)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.9279 31.6591L40.75 15.9644L63.6055 31.6591H70.9279Z",
    style: {
      fill: "var(--color-primary)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.75 -11.5032V-4.83813L40.75 15.9644L0.75 -11.5032Z",
    style: {
      fill: "var(--color-primary)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.75 29.831V24.4789L40.75 15.9644L80.75 29.831Z",
    style: {
      fill: "var(--color-primary)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.75 2.0979V7.44992L40.75 15.9645L0.75 2.0979Z",
    style: {
      fill: "var(--color-primary)"
    }
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 28.1499,
    cy: 40.8,
    r: 12,
    style: {
      fill: "var(--color-primary)"
    }
  }), _ref5, _ref6, _ref7));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgCheckIn, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/check-in.96e1d359.svg";
export { ForwardRef as ReactComponent };